<template>
  <div style="border: 1px solid #dedfe0;width:100%;border-radius: 4px;">
    <Toolbar
      style="border-bottom: 1px solid #dedfe0;width:100%;border-radius: 4px;"
      :editor="editorRef"
      :defaultConfig="toolbarConfig"
      :mode="mode"
    />
    <Editor
      style="height: 300px; overflow-y: hidden;;width:100%;border-radius: 4px;"
      v-model="valueHtml"
      :defaultConfig="editorConfig"
      :mode="mode"
      @onCreated="handleCreated"
      @onChange="onChange"
    />
  </div>
</template>
<script setup>
import '@wangeditor/editor/dist/css/style.css' // 引入 css
import { onBeforeUnmount, ref, shallowRef, onMounted, defineProps,defineEmits,defineExpose } from 'vue'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import { upload } from "@/api/common";

const props = defineProps({
  content:{
    type:String,
    default:''
  }
});

//配置
const editorConfig = {
  mode: 'default',
  MENU_CONF: {},
  placeholder: '请输入内容...',
}
editorConfig.MENU_CONF['uploadImage'] = {
    fieldName: 'picture',
    async customUpload(file, insertFn) {
        const form = new FormData()
        form.append('file', file)
        upload(form).then(res => {
            let url = res.data.url
            // console.log(res)
            insertFn(url)    //将图片插入编辑器
        })
    }
}
editorConfig.MENU_CONF['uploadVideo'] = {
    fieldName: 'picture',
    async customUpload(file, insertFn) {
        const form = new FormData()
        form.append('file', file)
        upload(form).then(res => {
            let url = res.data.url
            // console.log(res)
            insertFn(url)    //将视频插入编辑器
        })
    }
}

const emits = defineEmits(["update:content"]);
// const editor = ref(null)
const mode = ref('default')
// 编辑器实例，必须用 shallowRef
const editorRef = shallowRef()

// 内容 HTML
const valueHtml = ref('')
defineExpose({ valueHtml });


// 模拟 ajax 异步获取内容
onMounted(() => {
  // 这里延时了200毫秒才成功，直接赋值失败
  // valueHtml.value = props.content
  // console.log(Toolbar.getConfig().toolbarKeys)
  setTimeout(() => {
    valueHtml.value = props.content
    // console.log('editor----',valueHtml.value)
  }, 1000);
})

const toolbarConfig = {
  toolbarKeys: [

  'headerSelect',

    '|',

    'bold', 'underline','italic','blockquote','bulletedList','numberedList','todo','insertTable','insertLink',
    'uploadImage',
    //'insertImage',
    'divider'

        // 'headerSelect',
        // 'blockquote',
        // 'bold',
        // 'underline',
        // 'italic',
        // // 'group-more-style',
        // 'color',
        // 'bgColor',

        // 'bulletedList',
        // 'numberedList',
        // 'insertTable',
        // 'insertLink',
        // 'divider',
        // 'image'

  ]
}
// const editorConfig = { 
//   placeholder: '请输入内容...',
// }

// 组件销毁时，也及时销毁编辑器
onBeforeUnmount(() => {
  const editor = editorRef.value
  if (editor == null) return
  editor.destroy()
})

const onChange = (e)=>{
  emits("update:content",e.getHtml())
}
const handleCreated = (editor) => {
  editorRef.value = editor // 记录 editor 实例，重要！
}
</script>    
